import styled from "styled-components";

import * as typography from "@/styles/typography";

export const Title = styled(typography.Heading1)`
  margin: 0 0 0.5rem;
`;

export const IntroText = styled(typography.Paragraph)`
  margin-bottom: 1.5rem;
  opacity: 0.6;
`;

export const PageContentWrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 2rem 1.5rem 1.5rem;
`;

export const FlexPageContentWrapper = styled(PageContentWrapper)`
  display: flex;
  max-width: none;
`;

export const FlexNoPaddingContentWrapper = styled(FlexPageContentWrapper)`
  padding: 0;
`;
